export default __webpack_public_path__ + "static/media/m_use_action_back1.416e789a.png";